import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  actionButton: {
    cursor: 'pointer',
  },
  conditionalTemplateQuestionActionButton: {
    color: theme.palette.primary.dark,
  },
  menu: {
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: `0px ${theme.spacing(5)} ${theme.spacing(6)} -${theme.spacing(1)} rgba(0, 0, 0, 0.08), 
                0px ${theme.spacing(2)} ${theme.spacing(2)} -${theme.spacing(1)} rgba(0, 0, 0, 0.03)`,
    backgroundColor: '#fff',
  },
  menuItem: {
    padding: `0 ${theme.spacing(2)}`,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    justifyContent: 'flex-start',
    textAlign: 'left',
  },
  redText: {
    color: theme.palette.error.main,
  },
  redButtonColor: {
    color: theme.palette.error.main,
  },
}));
